var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 664.913,
    height: 705.244,
    viewBox: "0 0 664.913 705.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-106.023 -110.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(309.812 110.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(0 75.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(114.326 5.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M196.74-43.549A151.308,151.308,0,0,0,223.764-25.53c-13.323-24.316-6.187-76.112-4.987-68.538,5.762,36.21,27.438,77.167,36.868,79.892.065,0,.1.035.162.039,25.513,5.128,49.5.957,69.967-7.037a.217.217,0,0,0-.058-.122C308.191-49,313.874-101.8,314.927-98.468c11.441,35.714,39.8,58.4,45.032,58.794h.033c20.895-14.74,32.671-30.213,30.054-32.1-19-13.756-33.25-46.309-45.667-80.492l0-.029c-12.28-33.7-16.888-82.779-35.7-113.52-17.217-28.14-56.009-36.461-79.482-24.8C167.611-260,185.089-53.2,196.74-43.549Z",
    transform: "translate(-177.657 295.721)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M210.889-282.565c-5.314,1.621-9.779,4.858-13.785,8.277a84.4,84.4,0,0,0-10.641,11.5,133.726,133.726,0,0,0-14.979,26.608c-8.147,18.542-12.594,55.881-14.865,75.646a310.424,310.424,0,0,0-.033,59.631c.4,4.962,1.131,9.9,1.681,14.848l2.187,14.794,2.826,14.71,3.313,14.626-2.316-14.753-1.969-14.774L160.65-86.239c-.373-4.939-.928-9.866-1.15-14.807-1.234-19.738-1.4-39.539.82-59.135,1.912-19.608,6.425-56.616,13.769-75.13a135.2,135.2,0,0,1,13.848-26.631,81.82,81.82,0,0,1,9.853-11.759,52.713,52.713,0,0,1,6.045-5.009A28.22,28.22,0,0,1,210.889-282.565Z",
    transform: "translate(-155.165 285.871)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M719.912-33.7a256.946,256.946,0,0,1-15.239-22.118c-4.767-7.522-9.213-15.2-13.236-23.028-3.974-7.848-7.784-15.755-10.974-23.853s-6.083-16.37-9.144-24.555c-6.312-16.34-12.332-50.3-19.72-66.343-3.74-8-7.641-15.959-12.141-23.678a118.909,118.909,0,0,0-7.489-11.227c-2.76-3.565-5.822-7.149-10.006-9.472,3.938,2.612,6.641,6.294,9.171,9.937a115.611,115.611,0,0,1,6.678,11.463c4.127,7.791,7.708,15.807,11.1,23.877,6.8,16.142,12.825,50.046,18.853,66.449,3.174,8.17,6.141,16.35,9.491,24.527a214.341,214.341,0,0,0,11.591,23.94C697.64-62.273,707.709-47.271,719.912-33.7Z",
    transform: "translate(-504.664 252.485)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(159.081 146.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M382.28,350.941c16.082,36.13,79,152.479,117.835,159.449,25.479,4.574,127.289-8.991,144.01-33.794,7.286-10.809-8.316-83.778-21.83-80.371s-95.039,17.178-105.2,14.617c-10.106-2.547-88.687-86.654-117.625-107.2C349.565,268.226,373.619,331.484,382.28,350.941Z",
    transform: "translate(-359.901 -286.73)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M564.559,373.172,570.7,483.431s-80.434,17.68-115.539,5.553c-42.627-14.726-104.995-146.73-113.537-168.428-14.017-35.619-10.134-57.187,9.734-51.914,7.72,1.985,17.872,8.067,30.314,19.028,13.024,11.415,87.8,85.507,111.4,99.5C506.263,395,564.559,373.172,564.559,373.172Z",
    transform: "translate(-333.27 -267.852)",
    fill: "#f7d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M525.009,533.737a24.376,24.376,0,0,0-6.069,3.2,24.319,24.319,0,0,0,6.681-1.539,23.844,23.844,0,0,0,6.069-3.184A23.649,23.649,0,0,0,525.009,533.737Zm-60.6-86.6a23.748,23.748,0,0,0-6.053,3.184,26.245,26.245,0,0,0,12.735-4.723A23.8,23.8,0,0,0,464.413,447.134ZM403.28,394.8a24.374,24.374,0,0,0-6.069,3.2,26.375,26.375,0,0,0,12.75-4.723A24.177,24.177,0,0,0,403.28,394.8Zm44.438,118.531a24.063,24.063,0,0,0-6.069,3.184,26.246,26.246,0,0,0,12.735-4.723A23.561,23.561,0,0,0,447.718,513.335Zm71.119-42.495a24.113,24.113,0,0,0-6.068,3.2,24.319,24.319,0,0,0,6.681-1.54,23.841,23.841,0,0,0,6.069-3.184A23.659,23.659,0,0,0,518.836,470.84Zm-106.8-19.282a24.289,24.289,0,0,0-6.054,3.2,24.325,24.325,0,0,0,6.681-1.54,23.8,23.8,0,0,0,6.054-3.2A24.332,24.332,0,0,0,412.039,451.558Zm159.994,60.88c-.254-1.016-.583-2.018-.927-3a24.385,24.385,0,0,0-3.2-6.069,23.793,23.793,0,0,0,1.539,6.681,25.032,25.032,0,0,0,2.75,5.471Zm-84.5,6.143a24.322,24.322,0,0,0-3.184-6.069,24.3,24.3,0,0,0,1.525,6.681,23.886,23.886,0,0,0,3.2,6.069A23.666,23.666,0,0,0,487.537,518.581ZM434,424.175a24.286,24.286,0,0,0-3.2-6.053,24.319,24.319,0,0,0,1.54,6.681,23.742,23.742,0,0,0,3.184,6.053A23.772,23.772,0,0,0,434,424.175ZM375.119,366.21a24.07,24.07,0,0,0-3.184-6.069,26.246,26.246,0,0,0,4.723,12.735A23.57,23.57,0,0,0,375.119,366.21Zm83.39,180.128a23.682,23.682,0,0,0-6.547-2.033,23.87,23.87,0,0,0,5.8,3.632,24.192,24.192,0,0,0,6.547,2.033A24.154,24.154,0,0,0,458.509,546.338Zm73.346-45.365a23.854,23.854,0,0,0-6.547-2.018,26.719,26.719,0,0,0,12.361,5.665A24.764,24.764,0,0,0,531.855,500.973ZM507.7,561.524a23.674,23.674,0,0,0-6.547-2.033A19.6,19.6,0,0,0,504.771,562c1.181-.06,2.347-.119,3.528-.194C508.1,561.719,507.895,561.614,507.7,561.524ZM448.39,475.5a23.669,23.669,0,0,0-6.547-2.033,26.565,26.565,0,0,0,12.346,5.665A23.869,23.869,0,0,0,448.39,475.5Zm-89.653-77.83a23.678,23.678,0,0,0-6.547-2.033,23.867,23.867,0,0,0,5.8,3.632,24.2,24.2,0,0,0,6.547,2.033A24.159,24.159,0,0,0,358.737,397.673Zm55.6,96.021a23.355,23.355,0,0,0-2.018,6.547,24.224,24.224,0,0,0,3.632-5.814,24.733,24.733,0,0,0,2.033-6.547A24.294,24.294,0,0,0,414.34,493.694Zm-29.879-61.642a23.344,23.344,0,0,0-2.018,6.547,24.237,24.237,0,0,0,3.632-5.814,24.731,24.731,0,0,0,2.033-6.547A24.775,24.775,0,0,0,384.461,432.052ZM479.6,481.557a24.186,24.186,0,0,0-2.033,6.547,23.473,23.473,0,0,0,3.647-5.8,24.726,24.726,0,0,0,2.033-6.547A23.75,23.75,0,0,0,479.6,481.557ZM338.035,365.9c.15.822.314,1.644.508,2.5a21.718,21.718,0,0,0,1.48-5.232A18.2,18.2,0,0,0,338.035,365.9Z",
    transform: "translate(-336.838 -336.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M1184.838,825.906c-1.394-16.266-4.674-83.039-4.407-97.515.019-1,.659-1.235.775-.188,5.355,48.644,3.721,81.6,4.273,97.625C1185.493,826.229,1184.875,826.32,1184.838,825.906Z",
    transform: "translate(-967.541 -612.013)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M341.611,320.55c8.526,21.7,70.932,153.727,113.536,168.437,10.5,3.631,25.117,4.581,40.411,4.175L348.706,268.1c-4.22-.649-7.624.067-10.087,2.046C330.7,276.357,331.468,294.806,341.611,320.55Z",
    transform: "translate(-333.27 -267.861)",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(21.148 145.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M-215.642,491.086l220.826-.518-12.2-75.928s17.463-21.194,14.158-44.185C3.517,345.261-41.9,281.419-45.726,277.82c-15.369-14.428-31.649-17.019-47.285-11.812l-.036,0C-165.247,311.4-215.642,491.086-215.642,491.086Z",
    transform: "translate(215.642 -263.534)",
    fill: "#f7d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M-159.415,463.765a29.771,29.771,0,0,0-3.722,1.7c-.15.434-.3.852-.449,1.27a28.609,28.609,0,0,0,4.783-1.315,23.655,23.655,0,0,0,6.069-3.2A23.793,23.793,0,0,0-159.415,463.765Zm79.788-145.017a24.285,24.285,0,0,0-6.053,3.2,24.217,24.217,0,0,0,6.666-1.539,23.649,23.649,0,0,0,6.069-3.2A24.321,24.321,0,0,0-79.627,318.747Zm104.2,21.494a20.208,20.208,0,0,0-2.929,1.824,18.378,18.378,0,0,0,3.662-.6C25.063,341.063,24.809,340.66,24.57,340.242ZM-32.319,373.29a24.323,24.323,0,0,0-6.069,3.184,24.176,24.176,0,0,0,6.681-1.525,24.122,24.122,0,0,0,6.069-3.2A23.787,23.787,0,0,0-32.319,373.29Zm-28.355,86.469a24.05,24.05,0,0,0-6.069,3.184,24.3,24.3,0,0,0,6.681-1.525,23.792,23.792,0,0,0,6.054-3.2A23.562,23.562,0,0,0-60.674,459.759Zm97.142-64.138a24.287,24.287,0,0,0-6.054,3.2,24.328,24.328,0,0,0,6.681-1.54,23.809,23.809,0,0,0,6.054-3.2A24.325,24.325,0,0,0,36.468,395.621Zm-144.9,3.857a24.22,24.22,0,0,0-6.053,3.184,24.3,24.3,0,0,0,6.681-1.525,24.283,24.283,0,0,0,6.053-3.2A23.789,23.789,0,0,0-108.43,399.477ZM.49,457.4a24.063,24.063,0,0,0-6.069,3.183A24.3,24.3,0,0,0,1.1,459.056a24.029,24.029,0,0,0,6.054-3.2A23.562,23.562,0,0,0,.49,457.4ZM-58.118,286.536c-.15-.374-.3-.732-.448-1.106-.493.344-.972.7-1.45,1.061.09.224.164.434.239.658a23.887,23.887,0,0,0,3.2,6.069A24.319,24.319,0,0,0-58.118,286.536Zm-55.1,175.39a24.327,24.327,0,0,0-3.184-6.069,24.3,24.3,0,0,0,1.525,6.681,24.379,24.379,0,0,0,3.2,6.069A23.674,23.674,0,0,0-113.213,461.926Zm79.4-34.573A24.236,24.236,0,0,0-37,421.3a24.3,24.3,0,0,0,1.525,6.681,24.292,24.292,0,0,0,3.2,6.054A23.792,23.792,0,0,0-33.814,427.354ZM-61.9,352.827a24.283,24.283,0,0,0-3.2-6.053,23.69,23.69,0,0,0,1.539,6.666,23.6,23.6,0,0,0,3.184,6.069A24.3,24.3,0,0,0-61.9,352.827ZM35.676,479.594a23.585,23.585,0,0,0-3.184-6.069,24.3,24.3,0,0,0,1.525,6.681,24.024,24.024,0,0,0,3.2,6.053A23.562,23.562,0,0,0,35.676,479.594ZM-.451,310.272A24.072,24.072,0,0,0-3.635,304.2a26.245,26.245,0,0,0,4.723,12.735A23.572,23.572,0,0,0-.451,310.272ZM-85.127,433.228a23.841,23.841,0,0,0-6.547-2.018,24.235,24.235,0,0,0,5.814,3.632,24.188,24.188,0,0,0,6.547,2.033A24.77,24.77,0,0,0-85.127,433.228ZM-6.7,505.288a18.542,18.542,0,0,0,2.436,1.794l3.557-.015A22.424,22.424,0,0,0-6.7,505.288Zm-129.562-12.795a24.184,24.184,0,0,0-6.547-2.033,23.566,23.566,0,0,0,5.814,3.647,24.465,24.465,0,0,0,6.532,2.033A23.462,23.462,0,0,0-136.262,492.493ZM-2.5,414.932A23.929,23.929,0,0,0-9.031,412.9a23.475,23.475,0,0,0,5.8,3.647,24.158,24.158,0,0,0,6.547,2.018A24.239,24.239,0,0,0-2.5,414.932Zm-14.335-73.2A23.675,23.675,0,0,0-23.38,339.7a23.865,23.865,0,0,0,5.8,3.632,24.19,24.19,0,0,0,6.547,2.033A24.156,24.156,0,0,0-16.834,341.736ZM-102.84,362a23.684,23.684,0,0,0-2.033,6.547,23.952,23.952,0,0,0,3.632-5.814,23.425,23.425,0,0,0,2.033-6.532A23.874,23.874,0,0,0-102.84,362Zm69.3,120.16a24.169,24.169,0,0,0-2.018,6.547,23.869,23.869,0,0,0,3.632-5.8,24.194,24.194,0,0,0,2.033-6.547A24.686,24.686,0,0,0-33.545,482.165ZM8.891,376.115a23.345,23.345,0,0,0-2.018,6.547,24.237,24.237,0,0,0,3.632-5.814,24.729,24.729,0,0,0,2.033-6.547A24.774,24.774,0,0,0,8.891,376.115Zm-94.84,112.223a24.188,24.188,0,0,0-2.033,6.547,23.474,23.474,0,0,0,3.647-5.8,24.162,24.162,0,0,0,2.018-6.547A24.157,24.157,0,0,0-85.949,488.338ZM-133.9,433.377a24.033,24.033,0,0,0-2.033,6.547,23.846,23.846,0,0,0,3.647-5.815,24.007,24.007,0,0,0,2.018-6.547A24.243,24.243,0,0,0-133.9,433.377Zm67.532-35.544a23.417,23.417,0,0,0-2.033,6.532,23.854,23.854,0,0,0,3.632-5.8,24.183,24.183,0,0,0,2.033-6.547A24.23,24.23,0,0,0-66.368,397.833Zm27.189-84.8a23.418,23.418,0,0,0-2.033,6.532,23.863,23.863,0,0,0,3.632-5.8,24.2,24.2,0,0,0,2.033-6.547A24.232,24.232,0,0,0-39.18,313.038Z",
    transform: "translate(176.666 -279.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M554.307,442.023c4.267,7.1,8.982,13.966,13.449,20.969-1.8-4.959-3.57-9.93-5.549-14.821-.04-.1.1-.182.149-.082A102.432,102.432,0,0,1,570,466.565a140.657,140.657,0,0,1,8.921,16.487,65.858,65.858,0,0,1,5.987,21.61,55.709,55.709,0,0,1-3.137,22.245c-2.82,8.251-6.937,15.958-11.187,23.545-.563,1.005-1.961.076-1.492-.922,6.266-13.356,13.185-27.408,12.556-42.552-.621-14.957-7.593-28.771-14.43-41.758-4.118-7.823-8.312-15.682-13.406-22.924C553.605,442,554.117,441.706,554.307,442.023Z",
    transform: "translate(-360.424 -397.07)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(268.906 198.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 162.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M819.718,1104.308l-3.734,21.175H933.392a14.363,14.363,0,0,0,13.566-11.532l1.7-9.642Z",
    transform: "translate(-806.305 -1104.308)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M770.5,1113.95l1.7-9.642h23.066l-1.7,9.642A14.363,14.363,0,0,1,780,1125.483a9.584,9.584,0,0,1-7.565-3.372A9.962,9.962,0,0,1,770.5,1113.95Z",
    transform: "translate(-770.324 -1104.308)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M900.744,349.214,870.39,521.361H976.265a14.364,14.364,0,0,0,13.566-11.533l30.354-172.147H914.311a13.687,13.687,0,0,0-8.755,3.373A14.134,14.134,0,0,0,900.744,349.214Z",
    transform: "translate(-849.179 -337.681)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(47.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M1054.792,337.681l-6.132,34.775H1177.6l4.1-23.242c1.122-6.365-3.135-11.533-9.5-11.533Z",
    transform: "translate(-1037.128 -337.681)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M998.352,349.214l-4.1,23.242h23.065l4.1-23.242c1.122-6.365-3.134-11.533-9.5-11.533a13.686,13.686,0,0,0-8.755,3.373A14.133,14.133,0,0,0,998.352,349.214Z",
    transform: "translate(-994.254 -337.681)",
    fill: "#dbdbdb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(87.676 41.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M1251.707,651.74c4.309,12.285,16.743,28.294,16.874,37.97a11.1,11.1,0,0,1-7.366,11.007s9.026,5.766,7.7,14.567c-.684,4.528-8.518,7.414-8.518,7.414s7.032,4.937,5.369,12.69c-1.327,6.177-8.977,8.144-8.977,8.144s4.537,7.88,1.169,13.739c-6.832,11.883-60.757,6.153-66.977-14.6-2.9-9.671,10.2-7.557,10.2-7.557s-18.1-7.589-17.2-18.737,17.746-7.373,17.746-7.373-17.473-7.508-15.376-18.971c2.181-11.935,18.388-5.272,18.388-5.272s-11.127-9.4-7.512-17.812c5.967-13.885,26.754,6.582,38.9,5.029l8.616-18.847Z",
    transform: "translate(-1183.943 -626.244)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M1479.749,575.092c-3.064-11.987,12.732-24.71,11.449-36.594-1.735-16.077-21.06-2.552-27.419,19.853l-1.878,18.261Z",
    transform: "translate(-1402.981 -531.46)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(16.208 57.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M1315.874,1049.771a.143.143,0,0,1,.024.284c-18.2,2.437-38.937-.462-55.2-9.215-.534-.286-.3-1.279.35-1.074C1279.535,1045.582,1296.406,1049.27,1315.874,1049.771Z",
    transform: "translate(-1260.404 -989.163)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M1322.338,933.289c.211,0,.206.355-.019.384-18.764,2.409-42.034-1.5-59.591-13.8-.6-.421-.72-1.4.01-.97C1275.032,926.2,1304.811,932.926,1322.338,933.289Z",
    transform: "translate(-1261.844 -893.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M1275.468,801.2c17.292,11.139,36.414,15.614,56.716,17.388.265.022.2.395-.021.435-10.168,1.839-22.99-.64-32.8-3.414a54.224,54.224,0,0,1-24.279-13.8C1274.81,801.541,1275.1,800.964,1275.468,801.2Z",
    transform: "translate(-1271.885 -801.146)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(145.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(9.791 83.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M316.447,80.4c.3,3.883,14.436,30.96,31.686,32.8,5.619.588,10.2-29.939,10.2-29.939l.854-2.176L371.1,50.607,337.7,21.109l-4.872-3.974s-2.711,8.552-5.981,19.234c-.155.494-.309.989-.467,1.521-.2.6-.4,1.164-.559,1.731-.509,1.589-1.022,3.215-1.5,4.845-.368,1.239-.733,2.441-1.071,3.756-.374,1.311-.71,2.589-1.085,3.9C318.756,65.12,316.343,78.753,316.447,80.4Z",
    transform: "translate(-316.444 -17.135)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M357.838,36.369a65.638,65.638,0,0,0,32.34,44.71L402.1,50.607l-33.406-29.5-4.872-3.974S361.107,25.687,357.838,36.369Z",
    transform: "translate(-347.436 -17.135)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M441.531-227.143c-7.565,56.925-42.514,58.822-54.787,57.177-11.141-1.493-48.888-7.993-47.246-65.394s30.5-71.88,56.163-69.813S449.1-284.068,441.531-227.143Z",
    transform: "translate(-323.874 308.187)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(64.343 59.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M691.5-39.627a37.575,37.575,0,0,1-3.637-1.58c-1.389-.622-2.559-.974-3.4-2.32a2.042,2.042,0,0,1,.5-2.442c1.536-1.177,3.428-.838,5.13-.158a7.448,7.448,0,0,1,4.048,3.516C695.077-40.929,693.2-39.068,691.5-39.627Z",
    transform: "translate(-646.373 54.827)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M554-73.478a37.755,37.755,0,0,0,3.966-.023c1.522-.026,2.736.111,4.041-.8a2.043,2.043,0,0,0,.5-2.444c-.95-1.686-2.821-2.118-4.654-2.162a7.445,7.445,0,0,0-5.1,1.641C551.221-76.081,552.214-73.632,554-73.478Z",
    transform: "translate(-547.356 78.905)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 11.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(3.739 1.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M566.121-7.615c0-.152-.333.128-.357.286-.573,3.869-1.88,8.205-5.592,8.854-.115.02-.139.215-.007.221C564.521,1.916,566.2-3.857,566.121-7.615Z",
    transform: "translate(-557.145 12.395)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M554.682-26.367c-6.1-1.588-8.831,10.737-3.176,12.208C557.071-12.712,559.8-25.036,554.682-26.367Z",
    transform: "translate(-548.416 26.508)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M540.976-31.338c-1.23.459-2.557,1.456-3.883,1.3-1.535-.184-2.384-1.726-3.09-3.184-.073-.152-.2-.067-.242.1-.558,2.354-.185,4.977,2.268,5.889,2.239.833,4.359-.892,5.474-3.136C541.71-30.79,541.472-31.523,540.976-31.338Z",
    transform: "translate(-533.535 33.303)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(34.269 18.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M671.141,6.635c.063-.138.257.248.216.4-.995,3.783-1.5,8.284,1.66,10.34.1.064.044.253-.081.205C668.865,16.027,669.592,10.059,671.141,6.635Z",
    transform: "translate(-669.911 -3.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M676.542-6.119c6.236.941,3.9,13.344-1.881,12.474C668.975,5.5,671.314-6.907,676.542-6.119Z",
    transform: "translate(-670.996 6.155)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M699.326-1.118c.856.843,1.6,2.22,2.757,2.517,1.34.345,2.6-.807,3.706-1.93.115-.116.193.006.167.171-.381,2.383-1.632,4.7-4,4.73-2.155.024-3.3-2.3-3.417-4.767C698.52-.853,698.981-1.457,699.326-1.118Z",
    transform: "translate(-691.347 2.458)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M558.691,123.157c.666,1.128,1.24,2.588,2.579,3.072a10.329,10.329,0,0,0,4.314.143.137.137,0,0,1,.112.237,5.268,5.268,0,0,1-5.345.759c-1.628-.759-2.076-2.464-2.069-4.139C558.282,123,558.594,122.993,558.691,123.157Z",
    transform: "translate(-552.063 -72.296)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(11.314 2.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M592.766-30.36s-.4,5.882-.967,8.578c-.054.252-.731.236-1.658.1-.047,0-.075.017-.106-.019a13.093,13.093,0,0,1-11.449-7.388.285.285,0,0,1,.479-.29c3.009,3.353,6.8,4.847,11,5.8.346-.707.356-10.1.79-10.039,1.5.182,4.2,1.791,5.834,2.666,1.2-12.227.425-24.546,1.8-36.7a.376.376,0,0,1,.741-.027c1.723,12.854.653,26.955-.259,39.613C598.877-26.491,593.749-29.676,592.766-30.36Z",
    transform: "translate(-578.56 67.985)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M331.414-243.049c13.149,2.687,17.094-18.106,17.094-18.106s15.206,1.557,21-22.343c0,0,4.349,15.957,24.025,22.869,4.165,1.463-8.042-12.449-8.042-12.449s14.185,18.944,47.295,19.252c2.342.022,6.777-34.809-16.054-51.194s-49.386-14.078-67.98-1.288c0,0-17.92,6.3-23.372,23.3S326.3-244.093,331.414-243.049Z",
    transform: "translate(-311.781 316.608)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 62.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M488.581-32.027a19.087,19.087,0,0,1-13.916-18.795,19.075,19.075,0,0,1,19.492-18.6,19.071,19.071,0,0,1,18.6,19.49v0a19.077,19.077,0,0,1-19.492,18.6A19.037,19.037,0,0,1,488.581-32.027Zm9.576-34.247a16.466,16.466,0,0,0-4.057-.6A16.529,16.529,0,0,0,477.21-50.763a16.523,16.523,0,0,0,16.114,16.885,16.529,16.529,0,0,0,16.889-16.115A16.536,16.536,0,0,0,498.156-66.275Z",
    transform: "translate(-425.111 69.429)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M671.857-6.257c-7.021-1.964-11.379-10.935-9.838-20.755a22.739,22.739,0,0,1,6.044-12.534c3.223-3.237,7.1-4.688,10.925-4.088,3.836.594,7.069,3.17,9.148,7.239a22.758,22.758,0,0,1,1.908,13.782C688.412-12.237,680.8-4.78,673.079-5.991A10.922,10.922,0,0,1,671.857-6.257Zm7.681-34.653a8.165,8.165,0,0,0-.944-.206c-2.992-.471-6.093.726-8.729,3.367a20.245,20.245,0,0,0-5.331,11.13c-1.409,8.991,2.577,17.118,8.939,18.11,6.338,1,12.642-5.51,14.056-14.5a20.218,20.218,0,0,0-1.663-12.231A10.5,10.5,0,0,0,679.539-40.911Z",
    transform: "translate(-565.159 50.215)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M618.485,3.677,617.17,1.494C620.4-.454,627.508-2.641,631.331,3l-2.108,1.428C625.806-.63,618.782,3.5,618.485,3.677Z",
    transform: "translate(-531.811 17.899)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M279.533-49.167l-2.054-1.506c.7-.957,7.031-9.357,12.793-9.388,5.384-.013,38.616,8.445,40.027,8.806l-.631,2.468c-9.525-2.435-35.223-8.748-39.381-8.726C286.481-57.494,281.236-51.481,279.533-49.167Z",
    transform: "translate(-277.479 62.415)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(1.649 60.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M306.479-57.789s-8.346-20.217-17.256-17.618-5.346,30.007,3.205,35.549,13.834-2.273,13.834-2.273Z",
    transform: "translate(-284.04 75.638)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M309.029-43.575c-.147-.047-.223.157-.1.238,5.947,4.1,8.042,10.925,9.055,17.744-1.407-2.85-3.758-4.764-7.512-3.171-.2.084-.093.387.1.389,2.805.021,4.633.915,5.965,3.461a28.805,28.805,0,0,1,1.92,5.874c.176.652,1.3.574,1.228-.148-.006-.053-.014-.109-.02-.163C321.676-27.648,317.79-40.748,309.029-43.575Z",
    transform: "translate(-302.628 51.637)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0.172 147.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M331.387,274.786l-8.031,26.234L289.1,271.605l-8.056,11.058s35.172,48.371,35.17,46.051l8.595-22.755L341.2,319.887,336.725,281.8Z",
    transform: "translate(-280.323 -271.605)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M337.891,331.7c-.95-6.264-1.73-12.6-2.969-18.812-.044-.221-.4-.291-.433-.023-.745,6.19,3.013,30.124,3.478,35.9-.023-.02-.05-.041-.072-.061-.686-.6-15.126-12.2-15.242-11.982-1.972,3.664-8.289,20.24-8.691,21.733-5.565-7.685-28.978-37.858-35.4-45.026a.219.219,0,0,0-.359.251c5.034,8.187,35.358,48.052,35.729,47.909.276.178,8.142-20.245,8.966-24.047,2.5,2.581,17.2,15.8,17.168,14.856A198.724,198.724,0,0,0,337.891,331.7Z",
    transform: "translate(-278.162 -302.364)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 9.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(5.503 154.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M-139.9,372.861c-13.313,57.3-51,121.413-74.852,140.252-14.519,11.467-61.018,11.569-63.108-18.508S-188.634,370.214-175.2,351.866-127.892,321.164-139.9,372.861Z",
    transform: "translate(277.899 -335.995)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M-139.9,372.861c-13.313,57.3-51,121.413-74.852,140.252-14.519,11.467-61.018,11.569-63.108-18.508S-188.634,370.214-175.2,351.866-127.892,321.164-139.9,372.861Z",
    transform: "translate(277.899 -335.995)",
    fill: "#f7d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M-244.942,558.448a24.289,24.289,0,0,0-6.054,3.2,24.217,24.217,0,0,0,6.667-1.54,23.655,23.655,0,0,0,6.069-3.2A23.794,23.794,0,0,0-244.942,558.448Zm79.788-145.017a24.29,24.29,0,0,0-6.053,3.2,24.212,24.212,0,0,0,6.666-1.539,23.648,23.648,0,0,0,6.069-3.2A24.319,24.319,0,0,0-165.154,413.431Zm-28.8,80.73a24.227,24.227,0,0,0-6.053,3.184,24.305,24.305,0,0,0,6.681-1.525,24.278,24.278,0,0,0,6.053-3.2A23.794,23.794,0,0,0-193.957,494.16ZM-216.722,468.5a24.119,24.119,0,0,0-3.2-6.069,24.327,24.327,0,0,0,1.54,6.681,23.893,23.893,0,0,0,3.2,6.069A24.2,24.2,0,0,0-216.722,468.5Zm-37.159,57.083a24.372,24.372,0,0,0-3.2-6.069,24.175,24.175,0,0,0,1.525,6.681,24.119,24.119,0,0,0,3.2,6.068A24.3,24.3,0,0,0-253.88,525.579Zm51.956,24.962a20.891,20.891,0,0,0,1.076,5.321c.388-.463.777-.957,1.181-1.45A20.258,20.258,0,0,0-201.924,550.541Zm54.5-103.031a24.287,24.287,0,0,0-3.2-6.054,23.691,23.691,0,0,0,1.539,6.666,25.736,25.736,0,0,0,2.556,5.187c.12-.389.254-.762.374-1.151v-.015A28.693,28.693,0,0,0-147.426,447.51Zm-84.855,48.01a24.158,24.158,0,0,0-6.547-2.018,23.869,23.869,0,0,0,5.8,3.632,24.192,24.192,0,0,0,6.547,2.033A24.684,24.684,0,0,0-232.282,495.521Zm43.915-38.833a23.684,23.684,0,0,0-2.033,6.547,23.952,23.952,0,0,0,3.632-5.814,23.425,23.425,0,0,0,2.033-6.532A23.869,23.869,0,0,0-188.367,456.688Zm-31.06,71.373a24.031,24.031,0,0,0-2.033,6.547,23.849,23.849,0,0,0,3.647-5.814,24.009,24.009,0,0,0,2.018-6.547A24.244,24.244,0,0,0-219.427,528.06Zm-57.307,20.059c-.389.882-.762,1.779-1.076,2.705a3.943,3.943,0,0,0,.015.6c.045.613.1,1.226.179,1.809a27.744,27.744,0,0,0,2.5-4.38,24.554,24.554,0,0,0,2.033-6.547A23.825,23.825,0,0,0-276.734,548.12Z",
    transform: "translate(277.837 -392.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M-187.716,599.582a61.454,61.454,0,0,0,18.92.115,51.294,51.294,0,0,0,17.448-6.241c11.383-6.551,19-17.631,25.779-28.553q11.138-17.953,20.871-36.731c6.5-12.518,12.456-25.307,18.223-38.175,2.905-6.482,5.561-13.066,8.316-19.611,2.734-6.494,5.393-13.019,7.8-19.643.6-1.666,1.179-3.343,1.751-5.02.053-.155.3-.087.247.071-2.152,6.853-4.2,13.761-6.522,20.558-.3.883-.629,1.755-.936,2.635,2.407-5.121,4.874-10.213,7.445-15.254.153-.3.57-.03.441.265-2.29,5.23-4.684,10.411-7.142,15.565-1.208,2.534-2.436,5.059-3.66,7.585q-1.756,4.73-3.619,9.423-8.017,20.082-17.839,39.32-9.8,19.243-21.072,37.686c-6.916,11.313-14.348,22.947-25.54,30.5a48.733,48.733,0,0,1-36.559,7.37,34.333,34.333,0,0,1-4.514-1.288A.3.3,0,0,1-187.716,599.582Z",
    transform: "translate(210.657 -418.083)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(50.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M-98.1-100.155c9.49-23.1,24.882-54.773,35.252-59.563,10.882-5.026,49.85-21.167,60.115-22s46.682,9.826,53.247,16.281c5.257,5.17-3.845,17.483-24.6,15.715-19.406-1.652-23.965-3-29.549-2.126-5.7.893-22.3,14.3-20.834,22.514.865,4.839,12.147,13.167,20.889,11.646S10.464-127.77,21.3-132.772s26.382-.041,26.194,4.455-5.912,5.143-17.723,17.541C22.172-102.8,16.694-86.98.785-74-7.21-67.471-23.053-48.7-23.053-48.7Z",
    transform: "translate(98.095 206.402)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(35.252 17.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M42.191-180.522c10.69-9.994,35.732-26.532,56.94-28.967,14.334-1.646,53.6,31.776,50.082,40.022s-11.192,6.3-22.2,2.025C123-169,103.145-182.489,98.236-178.86c-7.059,5.217-19.673,26.01-19.673,26.01Z",
    transform: "translate(-42.191 209.548)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M391.131-141.024c-3.182-10.615-14.112-18.655-25.246-25.65-.173-.109-.353.152-.181.261,2.835,1.785,20.261,15.97,25.255,25.5C391.016-140.806,391.163-140.918,391.131-141.024Z",
    transform: "translate(-284.358 177.467)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(35.252 16.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M42.191-180.506c10.69-9.994,35.732-26.532,56.94-28.967,14.334-1.646,42.651,35.477,39.131,43.723s-14.713,6.089-25.8-1.283c-3.583-2.383-14.388-15.071-19.3-11.442-7.058,5.217-24.342,18.231-24.342,18.231Z",
    transform: "translate(-42.191 210.383)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M187.535-171.005c1.709-1.571,2.3-2.125,4.036-3.667s3.487-3.046,5.324-4.451a17.6,17.6,0,0,1,5.117-3.207,8.915,8.915,0,0,1,5.659.327c4.122,1.479,7.246,5.143,10.3,8.121,3.407,3.323,10.746,9.182,17.271,10.145a12.9,12.9,0,0,0,5.365-.068,8.114,8.114,0,0,0,3.621-1.623c3.956-3.967,1.888-10.188-.659-14.872-4.745-8.728-12.252-16.106-19.729-22.505-1.837-1.572-3.712-3.1-5.588-4.621a19.555,19.555,0,0,0-7.138-4.186c-4.407-1.169-12.793,1.454-15.389,2.232-.2.059-.251-.251-.06-.311,3.149-.995,11.29-4.768,18.32-2.573,2.572.8,4.663,2.768,6.771,4.4,2.206,1.71,4.359,3.5,6.466,5.325a103.653,103.653,0,0,1,11.509,11.526c3.3,3.937,6.751,8.426,8.4,13.352,1.432,4.27.8,9.659-2.5,12.9-2.78,2.737-7.135,2.448-9.1,2.2a21.645,21.645,0,0,1-5.608-1.5,91.99,91.99,0,0,1-11.289-6.712c-3.465-2.532-6.273-6.031-9.943-8.256a7.678,7.678,0,0,0-5.858-1.106,20.448,20.448,0,0,0-5.316,2.819,62.546,62.546,0,0,0-9.389,6.678C187.34-169.931,186.82-170.348,187.535-171.005Z",
    transform: "translate(-150.759 212.94)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(26.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M9.011-224.162c4.261-4.966,15.015-27.2,21.388-33.22S63.84-282.951,73.212-279.39c11.778,4.474-6.482,23.072-15.151,30.438S46.53-226.019,46.53-226.019Z",
    transform: "translate(-9.011 279.82)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M183.043-207.447c-2.989,2.269-5.8,4.912-8.55,7.466-2.6,2.421-5.5,4.74-7.717,7.527a32.41,32.41,0,0,0-4.937,9.377c-.594,1.648-1.079,3.313-1.526,5.006-.487,1.846-.8,3.75-1.319,5.584-.055.195.239.3.3.105a81.454,81.454,0,0,1,3.9-9.715,44.292,44.292,0,0,1,5.616-9.228c4.467-5.622,10.075-10.218,14.593-15.795C183.586-207.345,183.255-207.607,183.043-207.447Z",
    transform: "translate(-121.3 225.67)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M260.036,19.809c4.634.348,8-1.457,11.029-3.731,2.865-2.151,5.595-4.486,8.48-6.614a37.156,37.156,0,0,1,9.2-5.435,42.3,42.3,0,0,1,11.8-1.963c3.85-.239,7.811-.018,11.362,1.655,2.908,1.371,5.95,4.376,4.38,7.913a14.083,14.083,0,0,1-3.25,4.153A36.167,36.167,0,0,1,309,19.069c-2.859,2.055-5.89,3.885-8.551,6.215-3.555,3.111-5.96,7.34-8.585,11.241-.969,1.441-7.174,11.28-9.539,14.607a57.819,57.819,0,0,1-6.655,7.952,80.613,80.613,0,0,1-7.63,6.215,48.354,48.354,0,0,0-7.97,7.14c-.107.127-.285-.048-.213-.179,3.052-5.51,8.472-9.2,13.394-12.845,6.392-4.729,20.561-29.123,23.126-32.436,4.271-5.515,10.759-8.155,15.639-12.955,1.12-1.1,2.833-2.683,2.8-4.409-.033-1.693-1.569-3-2.918-3.719-3.356-1.779-7.463-1.665-11.124-1.306-3.783.371-7.708.647-11.336,1.875a37.146,37.146,0,0,0-9.053,4.728c-3.193,2.21-6.271,4.515-9.62,6.483-3.167,1.862-6.786,3.153-10.823,2.423C259.759,20.065,259.842,19.794,260.036,19.809Z",
    transform: "translate(-169.897 68.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M446.11-140.491c-2.564-1.254-5.1-2.606-7.693-3.8-.066-.031-.036-.139.035-.111,3.08,1.223,6.252,2.237,9.347,3.432,2.444.944,4.982,2.329,6.008,4.892a7.192,7.192,0,0,1-1.441,7.05c-1.762,2.182-4.305,3.34-6.744,4.581a.117.117,0,0,1-.11-.207c3.715-2.153,9.5-6.5,6.463-11.434C450.656-138.237,448.3-139.42,446.11-140.491Z",
    transform: "translate(-303.572 178.435)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M419.195-55.583c2.926.085,6.147.023,8.736-1.523a6.554,6.554,0,0,0,2.6-2.737,6.531,6.531,0,0,0,.575-1.986,3.082,3.082,0,0,0-.275-2.109c-.126-.155.16-.286.2-.105a9.87,9.87,0,0,0,.474,1.139,4.58,4.58,0,0,1,.218,1.017,5.269,5.269,0,0,1-.169,2.038,6.658,6.658,0,0,1-2.586,3.58c-2.912,2.087-6.533,1.9-9.816.924A.123.123,0,0,1,419.195-55.583Z",
    transform: "translate(-289.114 118.33)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M-170.887,188.644c-6.359,22.983-54.749,145.506-68.269,162.792s-46.113,21.022-55.233-10.233,38.412-180.641,48.46-204.011C-240.334,124.18-168.586,180.33-170.887,188.644Z",
    transform: "translate(296.614 -30.945)",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M-163.486,245.278-258.463,190.2s-40.6,139.347-41.331,182.32c-.524,30.847,36.432,53.882,65.643,12.2S-163.486,245.278-163.486,245.278Z",
    transform: "translate(299.8 -72.093)",
    fill: "#f7d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M-241.929,196.92a24.968,24.968,0,0,0-3.513,5.635,24.166,24.166,0,0,0-2.018,6.547,23.86,23.86,0,0,0,3.632-5.8,24.378,24.378,0,0,0,2-6.323v-.015Zm-30.612,132.955a24.167,24.167,0,0,0-2.018,6.547,23.87,23.87,0,0,0,3.632-5.8,24.193,24.193,0,0,0,2.033-6.547A24.993,24.993,0,0,0-272.541,329.875Zm-7.025,57.293a24.021,24.021,0,0,0-2.033,6.547,23.845,23.845,0,0,0,3.647-5.815,24.552,24.552,0,0,0,2.033-6.547A23.833,23.833,0,0,0-279.566,387.168Zm57.307-20.059a24.032,24.032,0,0,0-2.033,6.547,23.849,23.849,0,0,0,3.647-5.815,24.008,24.008,0,0,0,2.018-6.547A24.243,24.243,0,0,0-222.259,367.108Zm31.927-140.264c-.015.134-.045.284-.06.418.09-.1.179-.209.254-.314Zm-.867,68.891a23.685,23.685,0,0,0-2.033,6.547,23.954,23.954,0,0,0,3.632-5.814,23.428,23.428,0,0,0,2.033-6.532A23.874,23.874,0,0,0-191.2,295.736Zm-43.8-15.6a23.516,23.516,0,0,0-2.033,6.547,24.237,24.237,0,0,0,3.632-5.815,24.027,24.027,0,0,0,2.033-6.547A24.232,24.232,0,0,0-234.994,280.131Zm32.525-16.517a24.18,24.18,0,0,0-6.547-2.033,23.474,23.474,0,0,0,5.8,3.647,24.158,24.158,0,0,0,6.547,2.018A24.152,24.152,0,0,0-202.469,263.614Zm-32.645,70.954a24.162,24.162,0,0,0-6.547-2.018,23.867,23.867,0,0,0,5.8,3.632,24.2,24.2,0,0,0,6.547,2.033A24.686,24.686,0,0,0-235.113,334.568Zm-14.2-87.561a23.868,23.868,0,0,0-6.547-2.033,24.283,24.283,0,0,0,5.815,3.647,24.158,24.158,0,0,0,6.547,2.018A24.239,24.239,0,0,0-249.313,247.008Zm-7.4,117.619a24.377,24.377,0,0,0-3.2-6.068,24.172,24.172,0,0,0,1.525,6.681,24.122,24.122,0,0,0,3.2,6.069A24.3,24.3,0,0,0-256.712,364.627Zm37.159-57.083a24.118,24.118,0,0,0-3.2-6.069,24.323,24.323,0,0,0,1.54,6.681,23.89,23.89,0,0,0,3.2,6.069A24.2,24.2,0,0,0-219.553,307.544Zm22.764,25.664a24.222,24.222,0,0,0-6.053,3.184,24.3,24.3,0,0,0,6.681-1.525,24.28,24.28,0,0,0,6.053-3.2A23.786,23.786,0,0,0-196.789,333.208Zm-63.436-33.272a23.8,23.8,0,0,0-6.054,3.2,24.878,24.878,0,0,0,6.681-1.54,23.791,23.791,0,0,0,6.053-3.2A23.786,23.786,0,0,0-260.225,299.936Zm37.174-69.7a24.374,24.374,0,0,0-6.069,3.2,24.321,24.321,0,0,0,6.681-1.54,23.9,23.9,0,0,0,6.068-3.2A24.191,24.191,0,0,0-223.051,230.237Zm55.065,22.241a24.291,24.291,0,0,0-6.053,3.2,24.213,24.213,0,0,0,6.666-1.539,23.648,23.648,0,0,0,6.069-3.2A24.319,24.319,0,0,0-167.986,252.479ZM-247.774,397.5a24.288,24.288,0,0,0-6.054,3.2,24.217,24.217,0,0,0,6.667-1.54,23.66,23.66,0,0,0,6.069-3.2A23.8,23.8,0,0,0-247.774,397.5Z",
    transform: "translate(286.173 -77.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(38.708 139.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M-61.134,326.2c-14.386-7.719-72.1-41.451-84.083-49.583-.831-.563-.675-1.227.265-.752,43.668,22.09,70.381,41.465,84.1,49.756C-60.505,325.825-60.768,326.392-61.134,326.2Z",
    transform: "translate(145.758 -275.699)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M52.144,477.531c10.03-18.834,19.662-37.872,28.319-57.376q3.633-8.184,7.111-16.437c2.224-5.293,4.5-10.593,6.488-15.981-1.991-1.391-10.719-7.094-11.662-7.974a.388.388,0,0,1,.4-.628c1.155.434,11.286,6.308,13.436,7.906.3.225-4.015,10.719-5.98,15.736s-3.987,10.009-6.077,14.974Q77.973,432.5,71.032,446.921q-7.457,15.547-15.692,30.657C50.614,486.213,39.231,501.779,52.144,477.531Z",
    transform: "translate(2.05 -353.127)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(263.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M854.262-566.04a49.915,49.915,0,0,1-49.907,49.907,49.6,49.6,0,0,1-29.732-9.842l-24.449,6.242L760.353-542.5a49.507,49.507,0,0,1-5.905-23.542,49.915,49.915,0,0,1,49.907-49.907A49.915,49.915,0,0,1,854.262-566.04Z",
    transform: "translate(-750.175 615.947)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M888.912-467.6l-16.9-14.836,4.724-5.829,10.714,9.09,23.848-26.988,6.368,5.7Z",
    transform: "translate(-840.069 538.544)",
    fill: "#29ca42"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(106.023 500.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(0 36.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 400.289,
    height: 271.758,
    rx: 33.78,
    transform: "translate(47.595 0)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M382.233,255.4h0Z",
    transform: "translate(56.623 13.595)",
    fill: "#dde7fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 495.48,
    height: 17.397,
    rx: 8.699,
    transform: "translate(0 261.197)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 382.233,
    height: 252.605,
    rx: 31,
    transform: "translate(56.623 9.495)",
    fill: "#aec3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(100.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 280.112,
    height: 298.294,
    fill: "#edf3ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(147.286 236.733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 53.537,
    height: 3.463,
    rx: 0.248,
    transform: "translate(0 7.874)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    d: "M.235,0H66.562A.236.236,0,0,1,66.8.236V3.227a.236.236,0,0,1-.236.236H.236A.236.236,0,0,1,0,3.227V.235A.235.235,0,0,1,.235,0Z",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(24.298 20.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M0,0H231.515V162.886H0Z",
    transform: "translate(0 29.456)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(0 20.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(54.289)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 0.372,
    height: 172.08,
    fill: "#1f1f89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(199.261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 0.372,
    height: 172.08,
    fill: "#1f1f89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(78.907)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 0.372,
    height: 172.08,
    fill: "#1f1f89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 141.603)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 231.515,
    height: 0.372,
    fill: "#1f1f89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0 107.514)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 231.515,
    height: 0.372,
    fill: "#1f1f89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 73.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 231.515,
    height: 0.372,
    fill: "#1f1f89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 39.334)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 231.515,
    height: 0.372,
    fill: "#1f1f89"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 231.515,
    height: 33.054,
    fill: "#4072e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(209.967 238.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M1894.1,1452.51c-5.22,1.6-10.311,2.431-14.315,2.117-6.1-.481-9.539-3.5-9.675-8.5-.109-3.971,1.637-7.447,5.056-10.266-.032-.271-.06-.542-.082-.814-.224-2.8.409-4.659,1.882-5.528,2.383-1.4,5.923.516,6.073.6l-.792,1.278c-.793-.436-3.15-1.4-4.453-.621-1.123.665-1.259,2.5-1.16,3.985a34.255,34.255,0,0,1,10.851-4.586,61.384,61.384,0,0,1,10.224-1.65,8.865,8.865,0,0,1,.088-.915c.108-.687.36-1.491,1.076-1.652a1.2,1.2,0,0,1,1.264.624,3.407,3.407,0,0,1,.48,1.8c1.136-.024,2.192-.005,3.127.059l.026-.056a16.035,16.035,0,0,1,.241-5.155c.4-1.714,1.048-2.581,1.961-2.665a1.207,1.207,0,0,1,1.242.726c.511,1.161-.447,4.3-1.833,7.314a.067.067,0,0,0,0,.016c1.3.207,2.182.547,2.459,1.022a1.064,1.064,0,0,1-.316,1.389,1.929,1.929,0,0,1-2.292.464,2.161,2.161,0,0,1-.84-.908,15.488,15.488,0,0,1-3.09,4.344,1.614,1.614,0,0,1-1.824.25,1.66,1.66,0,0,1-.4-.3,19.846,19.846,0,0,1-1.194,2.333c-1.639,2.718-3.486,4.117-5.34,4.033a3.108,3.108,0,0,1-2-.837,27.2,27.2,0,0,1-3.594,5.584,4.344,4.344,0,0,1-4.683,1.568c-3.041-.9-5.791-5.052-6.821-9.974a10.806,10.806,0,0,0-3.776,8.5c.118,4.269,2.89,6.646,8.239,7.067,13.5,1.062,37.179-10.8,38.974-19.52h0C1917.425,1440.726,1906.191,1448.809,1894.1,1452.51Zm-17.272-16.063c.823,5.193,3.575,9.008,5.911,9.7a2.75,2.75,0,0,0,3-1.086,25.231,25.231,0,0,0,3.774-6.094,8.606,8.606,0,0,1-.652-1.932,13.149,13.149,0,0,1,.007-5.672,41.205,41.205,0,0,0-7.391,2.43A24.554,24.554,0,0,0,1876.824,1436.448Zm14.414,2.428a1.807,1.807,0,0,0,1.379.887c1.186.047,2.614-1.148,3.908-3.288a19.017,19.017,0,0,0,1.617-3.45,13.865,13.865,0,0,1-.441-3.01c-1.738.132-3.632.354-5.582.687C1893.136,1432.572,1892.547,1435.73,1891.238,1438.876Zm8.54-5.825c.244.7.463.831.465.832a13.855,13.855,0,0,0,2.787-4c-.744-.026-1.583-.03-2.5-.008A17.241,17.241,0,0,1,1899.778,1433.051Zm-9.2-1.9a10.732,10.732,0,0,0-.2,5.536C1891.164,1434.232,1891.325,1432.11,1890.577,1431.149Zm15.433-.945s.005,0,.008,0Zm-.232-7.6a8.749,8.749,0,0,0-.372,1.549A10.877,10.877,0,0,0,1905.778,1422.608Z",
    transform: "translate(-1870.1 -1420.553)",
    fill: "#f77d48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(42.323 31.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M1364.756,797.219h2.072v11.789h-2.072Z",
    transform: "translate(-1364.756 -797.017)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M1380.493,797.219h1.92l6.316,8.151v-8.151h2.037v11.789h-1.734l-6.5-8.387v8.387h-2.038Z",
    transform: "translate(-1375.272 -797.017)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M1417.554,797.219h2.291l3.554,9.061,3.537-9.061h2.24l-4.9,11.873h-1.819Z",
    transform: "translate(-1400.038 -797.017)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M1454.919,802.706a6.164,6.164,0,1,1,6.147,6.1A6.04,6.04,0,0,1,1454.919,802.706Zm10.155,0a4.039,4.039,0,0,0-4.008-4.193,3.992,3.992,0,0,0-3.975,4.193,4.039,4.039,0,0,0,4.008,4.194A3.992,3.992,0,0,0,1465.074,802.706Z",
    transform: "translate(-1425.008 -796.609)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M1500,797.219h2.071v11.789H1500Z",
    transform: "translate(-1455.135 -797.017)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M1514.164,802.706a5.966,5.966,0,0,1,6.08-6.1,6.144,6.144,0,0,1,4.615,1.836l-1.33,1.533a4.689,4.689,0,0,0-3.3-1.465,4.205,4.205,0,0,0,0,8.387,4.621,4.621,0,0,0,3.386-1.532l1.33,1.347a6.083,6.083,0,0,1-4.783,2.088A5.937,5.937,0,0,1,1514.164,802.706Z",
    transform: "translate(-1464.599 -796.609)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M1553.2,797.219h8.741v1.852h-6.67v3.065h5.912v1.852h-5.912v3.166h6.754v1.853H1553.2Z",
    transform: "translate(-1490.688 -797.017)",
    fill: "#ebf3fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(18.264 188.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M911.367,1416.619l-104.424-.649a8.429,8.429,0,0,1-8.376-8.481l.682-109.754a8.429,8.429,0,0,1,8.481-8.376l104.424.649a8.429,8.429,0,0,1,8.376,8.481l-.682,109.754A8.429,8.429,0,0,1,911.367,1416.619Z",
    transform: "translate(-798.566 -1289.359)",
    fill: "#f5c902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M927.884,1339.635l-100.043-.622a3.707,3.707,0,0,1-3.684-3.73l.079-12.7a3.707,3.707,0,0,1,3.73-3.684l100.043.622a3.707,3.707,0,0,1,3.684,3.729l-.079,12.7A3.707,3.707,0,0,1,927.884,1339.635Z",
    transform: "translate(-816.665 -1310.249)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(11.385 41.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(20.595 20.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M921.07,1517.271l-8.565-.054a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.053,8.565A3.876,3.876,0,0,1,921.07,1517.271Z",
    transform: "translate(-908.405 -1500.902)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M920.644,1585.657l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.054-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.054a3.875,3.875,0,0,1,3.851,3.9l-.053,8.565A3.875,3.875,0,0,1,920.644,1585.657Z",
    transform: "translate(-908.103 -1549.268)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M920.219,1654.044l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.876,3.876,0,0,1,3.851,3.9l-.053,8.565A3.876,3.876,0,0,1,920.219,1654.044Z",
    transform: "translate(-907.803 -1597.634)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M994.717,1517.729l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.053,8.565A3.875,3.875,0,0,1,994.717,1517.729Z",
    transform: "translate(-960.49 -1501.227)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M994.291,1586.117l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.053,8.565A3.875,3.875,0,0,1,994.291,1586.117Z",
    transform: "translate(-960.189 -1549.593)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M993.866,1654.5l-8.565-.053a3.876,3.876,0,0,1-3.851-3.9l.053-8.565a3.876,3.876,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.053,8.565A3.875,3.875,0,0,1,993.866,1654.5Z",
    transform: "translate(-959.889 -1597.957)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M1065.309,1586.558l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.876,3.876,0,0,1,3.851,3.9l-.053,8.565A3.876,3.876,0,0,1,1065.309,1586.558Z",
    transform: "translate(-1010.416 -1549.905)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M1064.883,1654.943l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.85,3.9l-.053,8.565A3.875,3.875,0,0,1,1064.883,1654.943Z",
    transform: "translate(-1010.114 -1598.27)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M851.21,1444.962l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.032-5.08a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.031,5.08A3.875,3.875,0,0,1,851.21,1444.962Z",
    transform: "translate(-838.402 -1432.078)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M850.764,1516.666l-8.565-.054a3.875,3.875,0,0,1-3.851-3.9l.032-5.08a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.876,3.876,0,0,1,3.851,3.9l-.032,5.08A3.876,3.876,0,0,1,850.764,1516.666Z",
    transform: "translate(-838.086 -1482.79)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M850.318,1588.371l-8.565-.053a3.876,3.876,0,0,1-3.851-3.9l.032-5.08a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.031,5.08A3.876,3.876,0,0,1,850.318,1588.371Z",
    transform: "translate(-837.771 -1533.503)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M849.872,1660.075l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.032-5.08a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.031,5.08A3.876,3.876,0,0,1,849.872,1660.075Z",
    transform: "translate(-837.456 -1584.215)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M921.495,1448.885l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.876,3.876,0,0,1,3.851,3.9l-.053,8.564A3.876,3.876,0,0,1,921.495,1448.885Z",
    transform: "translate(-888.11 -1432.389)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M995.142,1449.343l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.053,8.565A3.876,3.876,0,0,1,995.142,1449.343Z",
    transform: "translate(-940.196 -1432.712)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M1066.159,1449.784l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.053,8.565A3.875,3.875,0,0,1,1066.159,1449.784Z",
    transform: "translate(-990.422 -1433.024)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M1132.474,1518.915l-8.565-.054a3.875,3.875,0,0,1-3.851-3.9l.053-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.054,8.565A3.875,3.875,0,0,1,1132.474,1518.915Z",
    transform: "translate(-1037.322 -1481.916)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M1132.9,1450.528l-8.565-.053a3.876,3.876,0,0,1-3.851-3.9l.054-8.565a3.875,3.875,0,0,1,3.9-3.851l8.565.053a3.875,3.875,0,0,1,3.851,3.9l-.053,8.565A3.875,3.875,0,0,1,1132.9,1450.528Z",
    transform: "translate(-1037.623 -1433.551)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M1131.624,1607.323l-8.565-.053a3.875,3.875,0,0,1-3.851-3.9l.177-28.586a3.875,3.875,0,0,1,3.9-3.851l8.566.053a3.874,3.874,0,0,1,3.85,3.9l-.177,28.586A3.875,3.875,0,0,1,1131.624,1607.323Z",
    transform: "translate(-1036.721 -1530.281)",
    fill: "#f99746"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(42.558 14.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M943.961,1344.219l.017-2.744.4-1.042a.839.839,0,0,1,.649.658l-.023,3.658-.263.26Zm.777,1.05.26.263-.023,3.658a.84.84,0,0,1-.658.649l-.385-1.048.017-2.744Z",
    transform: "translate(-943.933 -1340.432)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M957.065,1341.822l-.016,2.483-.789.779-.26-.263.021-3.4Zm-1.09,7.18.021-3.4.263-.259.779.789-.016,2.483Zm4.567.943-3.92-.024a.84.84,0,0,1-.649-.658l1.048-.385,3.136.02Zm-.34-8.365-3.123-.019-1.043-.4a.839.839,0,0,1,.658-.649l3.906.024Zm.244,2.745.017-2.744.4-1.042a.839.839,0,0,1,.649.657l-.023,3.658-.263.259Zm.777,1.05.26.263-.022,3.658a.84.84,0,0,1-.658.649l-.385-1.048.017-2.744Z",
    transform: "translate(-952.448 -1340.489)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M984.289,1341.991l-.016,2.483-.789.779-.26-.263.021-3.4Zm-1.09,7.18.021-3.4.263-.26.779.789-.015,2.483Zm4.568.943-3.92-.024a.839.839,0,0,1-.649-.658l1.048-.385,3.136.019Zm-.339-8.365-3.123-.019-1.043-.4a.839.839,0,0,1,.658-.649l3.906.024Zm.244,2.746.017-2.744.4-1.043a.839.839,0,0,1,.65.657l-.023,3.658-.263.259Zm.777,1.05.26.263-.023,3.658a.839.839,0,0,1-.657.649l-.385-1.047.017-2.744Z",
    transform: "translate(-971.702 -1340.609)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M1011.512,1342.16l-.016,2.483-.789.779-.26-.263.021-3.4Zm-1.09,7.18.021-3.4.263-.26.779.789-.016,2.483Zm4.568.943-3.92-.024a.839.839,0,0,1-.649-.657l1.048-.385,3.136.02Zm-.34-8.364-3.123-.019-1.043-.4a.839.839,0,0,1,.657-.649l3.906.024Zm.244,2.745.017-2.744.4-1.043a.839.839,0,0,1,.649.657l-.023,3.659-.263.259Zm.777,1.05.26.263-.023,3.658a.84.84,0,0,1-.657.65l-.385-1.048.017-2.744Z",
    transform: "translate(-990.955 -1340.729)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1038.737,1342.329l-.016,2.483-.789.779-.26-.263.021-3.4Zm-1.09,7.18.021-3.4.263-.26.779.789-.015,2.483Zm4.568.943-3.92-.024a.838.838,0,0,1-.649-.658l1.048-.385,3.136.019Zm-.34-8.365-3.123-.019-1.043-.4a.838.838,0,0,1,.657-.649l3.907.024Zm.245,2.746.017-2.744.4-1.043a.84.84,0,0,1,.649.657l-.023,3.658-.263.26Zm.777,1.05.26.263-.022,3.658a.84.84,0,0,1-.657.65l-.385-1.048.017-2.744Z",
    transform: "translate(-1010.21 -1340.848)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M1065.961,1342.5l-.015,2.483-.789.779-.26-.263.021-3.4Zm-1.09,7.18.021-3.4.263-.26.779.789-.015,2.483Zm4.567.943-3.92-.024a.838.838,0,0,1-.649-.657l1.048-.385,3.136.019Zm-.34-8.365-3.123-.019-1.043-.4a.839.839,0,0,1,.657-.649l3.907.024Zm.244,2.746.017-2.744.4-1.043a.84.84,0,0,1,.649.657l-.022,3.659-.263.26Zm.777,1.05.26.263-.023,3.658a.84.84,0,0,1-.657.649l-.385-1.047.017-2.744Z",
    transform: "translate(-1029.464 -1340.968)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M1093.184,1342.668l-.015,2.483-.789.779-.26-.263.021-3.4Zm-1.09,7.179.021-3.4.263-.26.78.788-.016,2.483Zm4.568.943-3.92-.024a.839.839,0,0,1-.649-.657l1.048-.385,3.136.02Zm-.34-8.365-3.123-.019-1.043-.4a.838.838,0,0,1,.657-.649l3.906.024Zm.244,2.746.017-2.744.4-1.043a.84.84,0,0,1,.649.657l-.023,3.659-.263.26Zm.778,1.05.26.263-.023,3.658a.839.839,0,0,1-.658.649l-.385-1.048.017-2.744Z",
    transform: "translate(-1048.716 -1341.088)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M1120.408,1342.837l-.016,2.482-.789.779-.26-.263.021-3.4Zm-1.09,7.18.021-3.4.263-.26.78.789-.016,2.483Zm4.567.943-3.919-.024a.839.839,0,0,1-.65-.658l1.048-.385,3.136.019Zm-.34-8.365-3.123-.02-1.042-.4a.839.839,0,0,1,.657-.649l3.907.024Zm.244,2.745.017-2.744.4-1.043a.839.839,0,0,1,.649.657l-.023,3.658-.262.26Zm.777,1.05.26.263-.023,3.658a.838.838,0,0,1-.657.65l-.385-1.048.017-2.744Z",
    transform: "translate(-1067.97 -1341.207)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M1147.632,1343.006l-.016,2.482-.789.779-.26-.263.021-3.4Zm-1.09,7.179.021-3.4.263-.26.779.789-.016,2.483Zm4.567.943-3.92-.024a.839.839,0,0,1-.649-.657l1.048-.385,3.136.019Zm-.34-8.365-3.123-.02-1.043-.4a.839.839,0,0,1,.658-.649l3.907.024Zm.244,2.746.017-2.744.4-1.043a.84.84,0,0,1,.65.657l-.023,3.659-.263.26Zm.778,1.05.259.263-.022,3.658a.84.84,0,0,1-.658.65l-.385-1.048.017-2.744Z",
    transform: "translate(-1087.224 -1341.327)",
    fill: "#2b478b"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.957f57b786112388c2fe726d87e5b796.svg";
export { ForwardRef as ReactComponent };